import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import PublicLayout from '../../../layouts/PublicLayout';
import useSEO from '../../../seo/use-seo';
import StandardPageHelmet from '../../../seo/components/StandardPageHelmet';
import { AboutUsHeroSection } from './AboutUs/AboutUsHeroSection';
import { AboutUsMissionVisionSection } from './AboutUs/AboutUsMissionVisionSection';
import { AboutUsCorePrinciplesSection } from './AboutUs/AboutUsCorePrinciplesSection';
import { AboutUsWhatMakesDifferentSection } from './AboutUs/AboutUsWhatMakesDifferentSection';
import { AboutUsJourneyCTASection } from './AboutUs/AboutUsJourneyCTASection';

const useStyles = makeStyles((theme) => ({
  pageContainer: {
    backgroundColor: '#0a0a0a',
    minHeight: '100vh',
    paddingBottom: '0px',
    color: '#fff',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '0px',
    }
  }
}));

export default function AboutUsPage() {
  const classes = useStyles();
  const seo = useSEO("login", {
    title: "About Us | SugarCribs",
    description: "Learn more about SugarCribs, our mission, vision, core principles, and premium community of creators and members."
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PublicLayout>
      <StandardPageHelmet seo={seo} />
      <div className={classes.pageContainer}>
        <AboutUsHeroSection />
        <AboutUsMissionVisionSection />
        <AboutUsCorePrinciplesSection />
        <AboutUsWhatMakesDifferentSection />
        <AboutUsJourneyCTASection />
      </div>
    </PublicLayout>
  );
}
